import { Entity } from "./Entity.abstract";

export class SchedulerEntity extends Entity {
    constructor({ _id, accountingId, companyIds, dates }) {
        super({ _id, accountingId, companyIds, dates });
    }

    has(companyId) {
        return this.props.companyIds.includes(companyId);
    }
}
